module.exports = __webpack_public_path__ + "img/shop-service-filter-cjdr.7df5fd24.png";